import { render } from "./BrandSeoSummary.vue?vue&type=template&id=0740a990"
import script from "./BrandSeoSummary.vue?vue&type=script&lang=js"
export * from "./BrandSeoSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__